var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.showEditBrandsModal ? _c('r-modal', {
    staticClass: "edit-brands-urls-modal",
    attrs: {
      "title": _vm.$t('urlsTable.batchActions.editBrands.title'),
      "close-action-label": _vm.$t('global.actions.cancel'),
      "action-label": _vm.$t('urlsTable.batchActions.editBrands.deleteBrands'),
      "alternate-action-label": _vm.$t('urlsTable.batchActions.editBrands.addBrands'),
      "action-disabled": _vm.disableAction,
      "alternate-action-disabled": _vm.disableAction,
      "fetching": _vm.loading
    },
    on: {
      "submit:alternate": _vm.onAddBrands,
      "submit": _vm.onRemoveBrands,
      "close": _vm.onClose
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function fn() {
        return [_c('label', [_vm._v(_vm._s(_vm.$t('urlsTable.batchActions.editBrands.subTitle')))]), _c('r-error-message', {
          attrs: {
            "errors": [_vm.fetchEditBrandsError]
          }
        }), _c('div', {
          staticClass: "mt-3"
        }, [_c('brands-dropdown', {
          on: {
            "change": _vm.onSelectBrand,
            "open:create-brand-modal": _vm.onClickCreateNewBrand
          }
        })], 1)];
      },
      proxy: true
    }], null, false, 105317239)
  }) : _vm._e(), _vm.showEditBrandsAlertModal ? _c('r-modal', {
    staticClass: "create-product-alert-modal",
    attrs: {
      "title": _vm.alertTitle
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function fn() {
        return [_c('div', {
          staticClass: "d-flex justify-center align-center"
        }, [_vm._v(" " + _vm._s(_vm.alertSuccessMessage) + " ")])];
      },
      proxy: true
    }, {
      key: "customActions",
      fn: function fn() {
        return [_c('r-button', {
          staticClass: "close-btn",
          attrs: {
            "outlined": true,
            "label": _vm.$t('global.actions.backToData')
          },
          on: {
            "click": function click() {
              return _vm.$emit('close:edit-brands-alert-modal');
            }
          }
        })];
      },
      proxy: true
    }], null, false, 1962761155)
  }) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }